import { Tabs, TabList, Tab, Flex } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { EventListSearchInput } from '@/components/ui/features/events-list/EventListSearch/EventListSearchInput';
import { AccessFrom } from '@/enums/AccessFrom';
import { EventListStatus } from '@/enums/EventListStatus';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { StatusStringParam } from '@/utils/url-query-string';

interface IUrlQueryStringParams {
  status: EventListStatus;
  query?: string;
  accessFrom: AccessFrom;
}
export const EventListTabs: FC = () => {
  const { t } = useTranslation();

  const statuses = Object.values(EventListStatus);

  const { status = EventListStatus.live, query, accessFrom } = useQueryParams<IUrlQueryStringParams>({
    status: StatusStringParam,
    accessFrom: StringParam,
  });

  return (
    <Flex
      flexDir={{ base: 'column-reverse', lg: 'row' }}
      justify="between"
      alignItems="center"
      borderBottom="1px solid"
      borderColor="gray.200"
    >
      <Tabs size="lg" index={!query && statuses.indexOf(status)} w="full">
        <TabList border="none">
          <NextLink shallow href={`/events-list?status=${EventListStatus.live}&accessFrom=${accessFrom}`}>
            <Tab mr="8" isDisabled={Boolean(query)}>
              {t(`eventListPage.liveStatusFilter`)}
            </Tab>
          </NextLink>
          <NextLink shallow href={`/events-list?status=${EventListStatus.upcoming}&accessFrom=${accessFrom}`}>
            <Tab isDisabled={Boolean(query)}>{t(`eventListPage.upcomingStatusFilter`)}</Tab>
          </NextLink>
        </TabList>
      </Tabs>
      <Flex mb={{ base: 4, lg: 0 }} maxW={{ base: '352px', md: '512px', lg: '398px' }} w="full" alignItems="center">
        <EventListSearchInput />
      </Flex>
    </Flex>
  );
};
